import Axios from 'axios';
import ApiClient from './ApiClient';
import { BONJIRI_TOKEN_KEY } from './ApiClient';

const client = new ApiClient();

export default {
  /**
   * Eメールアドレスとパスワードによるセッション作成
   */
  login: authInfo => {
    return client.post(
      'me/signin/email',
      {
        email: authInfo.email,
        password: authInfo.password
      },
      {
        headers: { [BONJIRI_TOKEN_KEY]: authInfo.temporaryToken }
      }
    );
  },

  checkPassword: authInfo => {
    console.log(authInfo);
    const client = Axios.create();
    return client.post(
      process.env.VUE_APP_API_HOST + 'me/signin/email',
      {
        email: authInfo.email,
        password: authInfo.password
      },
      {
        headers: { [BONJIRI_TOKEN_KEY]: authInfo.temporaryToken }
      }
    );
  },

  /**
   * メールアドレスの有効性をチェックする処理
   */
  emailConfirmed: param => {
    return new Promise((resolve, reject) => {
      client
        .get('me/email/confirmed', {
          headers: { [BONJIRI_TOKEN_KEY]: param.emailVerifyHash }
        })
        .then(result => {
          resolve(result);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  /**
   * Instagramログインページ処理
   * 最初に、キャンペーンハッシュを使って、URLの妥当性を検証するためのAPIを実行する
   * - 400系エラーはサーバサイドのエラーを返却し、
   * - 500系のエラーはハンドリング
   */
  prepare: param => {
    return new Promise((resolve, reject) => {
      client
        .get('me/campaign/prepare_by_hash', {
          params: {
            campaignHash: param.campaignHash
          }
        })
        .then(result => {
          resolve(result);
        })
        .catch(apiError => {
          reject(apiError); // TODO status codeでエラーハンドリング
        });
    });
  },
  /**
   * Instagram認証コードによりInstagramアクセストークンを取得する処理
   */
  instagramVerify: param => {
    return client.post(
      `me/instagram/verify`,
      {
        igName: param.igName
      },
      {
        headers: { [BONJIRI_TOKEN_KEY]: param.token }
      }
    );
  },
  /**
   * Twitter認証コードによりTwitterアクセストークンを取得する処理
   */
  twitterVerify: param => {
    return client.post(
      `me/twitter/verify`,
      {
        oauthToken: param.oauthToken,
        oauthVerifier: param.oauthVerifier
      },
      {
        headers: { [BONJIRI_TOKEN_KEY]: param.token }
      }
    );
  },
  verifyEmail: param => {
    let headers = null;
    if (param.signupToken) {
      //signup用のトークンがあった場合のみヘッダーに追加
      //ここで追加されない場合は、通常のアクセストークンが
      //ApiClientレベルで設定される
      headers = {
        headers: { [BONJIRI_TOKEN_KEY]: param.signupToken }
      };
    }
    return client.post(
      'me/email/verify',
      {
        email: param.email,
        password: param.password,
        isConsentToPrivacyPolicy: param.isConsentToPrivacyPolicy
      },
      headers
    );
  },
  temporaryTokenSignin: param => {
    return client.post('me/signin/temporary_token', {
      temporaryToken: param.temporaryToken
    });
  }
};
